import { render, staticRenderFns } from "./StepAddFeedback.vue?vue&type=template&id=bb85c608&scoped=true&"
import script from "./StepAddFeedback.vue?vue&type=script&lang=js&"
export * from "./StepAddFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb85c608",
  null
  
)

export default component.exports